// eslint-disable-next-line no-restricted-syntax
export enum SocureKycStatus {
  // Socure statuses
  ACCEPT = 'accept',
  REJECT = 'reject',
  REFER = 'refer',
  RESUBMIT = 'resubmit',
  REVIEW = 'review',
  // custom statuses
  MISSING = 'missing', // user hasn't go thorough KYC yet
  DOCV_IN_PROGRESS = 'docv_in_progress', // user uploaded documents for DocV, waiting for a decision to hit a webhook
}

// eslint-disable-next-line no-restricted-syntax
export enum APIUserRole {
  ADMIN = 'admin',
  USER = 'user',
  COMMISSIONER = 'commissioner',
}

type APIAuthUserResponse = {
  id: string; // UUID
  data: {
    id: string; // UUID
    firstName?: string;
    lastName?: string;
    /** @deprecated use handle instead */
    username: string;
    handle: string;
    avatarUrl?: string;
    email: string;
    emailVerified: boolean;
    referralCode: string;
    rypUserId?: string;
    ofpUserId?: string;
    channelId?: string;
    intercomIdentity?: {
      ios: string;
      android: string;
      jwt?: { web: string; ios: string; android: string };
      /** unix seconds */
      jwtExpiresAt?: number;
    };
  };
};

type APIAuthUserData = APIAuthUserResponse['data'];

type APIUserResponse = {
  id: string; // UUID
  data: {
    id: string; // UUID
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    mobileNumber: string;
    dateOfBirth: string; // Date-time
    verificationStatus: SocureKycStatus;
    status: string;
    createdAt: string; // Date-time
    timeout: {
      id: string;
      duration: number;
      createdAt: string; // Date-time
      expiresAt: string; // Date-time
    };
    isCommissioner?: boolean; // Doesn't exist in the payments-service yet
    marketingOptedIn?: boolean;
    role?: APIUserRole;
    // Various payment provider IDs
    aeropayId?: string;
    paypalPayerId?: string;
    paysafeId?: string;
    venmoId?: string;
    vippRegistrationId?: string;
  };
};

type User = APIAuthUserResponse['data'] & APIUserResponse['data'];

export type UserSsnStatus = 'provided' | 'required' | 'not_required';

export type APIUserSsnStatusResponse = {
  id: string;
  data: {
    userSsnStatus: UserSsnStatus;
  };
};

export type { APIAuthUserResponse, APIAuthUserData, APIUserResponse, User };
